<template>
  <v-row>
    <v-col cols="3" align-self="center"> {{ $t("referenceBooks.products.Hopper") }} #{{ hopperNumber }}: </v-col>

    <v-col cols="1" v-if="loading">
      <Loader style="width: 30px; height: 30px" />
    </v-col>

    <v-col cols="6" v-if="!loading">
      <v-text-field
        :value="hopperInfo.cardsCount"
        :label="$t('referenceBooks.devices.countCards')"
        :disabled="true"
      />
    </v-col>

    <v-col>
      <v-row>
        <div>
          <Promt
            class="mt-3"
            :dialogTitle="$t('referenceBooks.devices.addCards')"
            :textLable="$t('referenceBooks.devices.countCards')"
            :tooltipText="$t('referenceBooks.devices.addCards')"
            @ok="(data) => onAdd(data, 1)"
            :okText="$t('Ok')"
            :cancelText="$t('Cancel')"
            buttonIcon="mdi-plus"
          />
        </div>
        <div>
          <Promt
            class="mt-3"
            :dialogTitle="$t('referenceBooks.devices.removeCards')"
            :textLable="$t('referenceBooks.devices.countCards')"
            :tooltipText="$t('referenceBooks.devices.removeCards')"
            @ok="(data) => onAdd(data, 0)"
            :okText="$t('Ok')"
            :cancelText="$t('Cancel')"
            buttonIcon="mdi-minus"
          />
        </div>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Loader from '@/components/Loader';
import Promt from '@/components/Dialogs/Promt';

export default {
  name: 'CardsInHopperCount',
  props: {
    hopperNumber: {
      type: Number,
      required: true,
    },
    device: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      hopperInfo: {},
    };
  },
  methods: {
    async onAdd(data, param) {
      try {
        const response = await this.$axios.hoppers.changeCards(
          this.device.deviceId,
          this.hopperNumber,
          param,
          Number(data)
        );
        this.hopperInfo.cardsCount = response.data.cardsCount;
      } catch (error) {
        console.error('Ошибка при изменении карт:', error);
      }
    },
  },
  async mounted() {
    this.loading = true;
    try {
      const response = await this.$axios.hoppers.getCountCards(
        this.device.deviceId,
        this.hopperNumber
      );
      const json = response.data;

      if (!json || json.length === 0) {
        this.hopperInfo = {
          deviceId: this.device.deviceId,
          hopperId: this.hopperNumber,
          cardsCount: 0,
        };
      } else {
        this.hopperInfo = json.find((item) => item.hopperId == this.hopperNumber) || {
          deviceId: this.device.deviceId,
          hopperId: this.hopperNumber,
          cardsCount: 0,
        };
      }
    } catch (error) {
      console.error('Ошибка загрузки данных:', error);
    } finally {
      this.loading = false;
    }
  },
  components: {
    Loader,
    Promt,
  },
};
</script>
